import { render, staticRenderFns } from "./bills_agreement.vue?vue&type=template&id=ee35d922&"
import script from "./bills_agreement.vue?vue&type=script&lang=js&"
export * from "./bills_agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports